/* AS-Electronics · Reparatur-Konfigurator
   Globaler Drawer auf jeder Seite: schwebender Button unten rechts, Panel von rechts
   (Desktop) bzw. Bottom-Sheet (Mobil). Ablauf wie beim Wettbewerber, nativ, ohne iframe,
   ohne Filialwahl. Daten als JSON aus den Metaobjekten.
   Oeffentliche Schnittstelle: window.AsKfg.open({geraet:'iphone-13', reparatur:'display'})
   oder ein Event  document.dispatchEvent(new CustomEvent('as:kfg-open', {detail:{...}})). */
(function () {
  var drawer = document.querySelector('[data-kfg-drawer]');
  var inline = document.querySelector('[data-kfg-inline]');
  var root   = document.querySelector('[data-kfg]');
  var raw    = document.getElementById('AsKfgData');
  if ((!drawer && !inline) || !raw) return;
  var D = JSON.parse(raw.textContent);

  /* Katalog aus assets/as-reparatur-katalog.js dazumischen: Geraete, Reparaturarten und
     Festpreise als Premium (gepruefte Nachbau-/OEM-Qualitaet) und Original. Die Metaobjekte
     bleiben Vorrang - was dort gepflegt ist, ueberschreibt den Katalog. */
  D.preise = D.preise || {};
  D.preiseOriginal = D.preiseOriginal || {};
  (function katalog() {
    var K = window.AsReparaturKatalog;
    if (!K) return;
    var TYP = { 'Apple': 'Smartphone', 'Samsung': 'Smartphone', 'MacBook': 'Laptop' };
    var MARKE = { 'Apple': 'apple', 'Samsung': 'samsung', 'MacBook': 'apple' };
    var FAM = { 'Apple': 'iphone', 'Samsung': 'galaxy-s', 'MacBook': 'macbook' };

    var hatH = {}; D.hersteller.forEach(function (m) { hatH[m.h] = true; });
    [['apple', 'Apple'], ['samsung', 'Samsung']].forEach(function (m) {
      if (!hatH[m[0]] && K.GERAETE[m[1]] && K.GERAETE[m[1]].length) D.hersteller.push({ h: m[0], n: m[1] });
    });

    var hatT = {}; D.typen.forEach(function (t) { hatT[t.k] = true; });
    if (!hatT.Smartphone) D.typen.push({ k: 'Smartphone', l: 'Smartphone', s: 'Apple, Samsung', i: 'smartphone' });
    if (!hatT.Laptop && K.GERAETE.MacBook && K.GERAETE.MacBook.length) D.typen.push({ k: 'Laptop', l: 'MacBook', s: 'Air und Pro', i: 'laptop' });

    /* Sinnvolles Symbol je Reparaturart – greift auf das vorhandene Sprite zurueck. */
    var ICO = {
      display: 'display', displayglas: 'display', touchscreen: 'display', aussendisplay: 'display',
      akku: 'akku', tastatur: 'tastatur', backcover: 'rueckseite', gehaeuserahmen: 'gehaeuse', mittelrahmen: 'gehaeuse',
      kamera_haupt: 'kamera', kamera_front: 'kamera', kameraglas: 'kamera',
      ladebuchse: 'ladebuchse', kopfhoerer: 'ladebuchse', sim: 'ladebuchse',
      hoermuschel: 'lautsprecher', mikrofon: 'lautsprecher', lautsprecher: 'lautsprecher',
      wasserschaden: 'wasserschaden', vibration: 'werkzeug', lautstaerke: 'werkzeug',
      powerbutton: 'werkzeug', homebutton: 'werkzeug', stummschalter: 'werkzeug',
      fingerprint: 'werkzeug', flexkabel: 'werkzeug', antenne: 'werkzeug',
      kostenvoranschlag: 'frage', wertgutachten: 'schild'
    };
    var hatA = {}; D.arten.forEach(function (a) { hatA[a.h] = a; });
    var benutzt = {};
    Object.keys(K.GERAETE).forEach(function (mk) {
      K.GERAETE[mk].forEach(function (g) { Object.keys(g.p).forEach(function (ah) { (benutzt[ah] = benutzt[ah] || {})[TYP[mk]] = true; }); });
    });
    Object.keys(K.ARTEN).forEach(function (ah) {
      if (!benutzt[ah]) return;
      var a = K.ARTEN[ah];
      if (hatA[ah]) { hatA[ah].typen = []; hatA[ah].r = a.r; return; }
      D.arten.push({ h: ah, n: a.n, d: a.s, min: 0, gar: 12, i: ICO[ah] || 'werkzeug', typen: Object.keys(benutzt[ah]), r: a.r });
    });
    D.arten.sort(function (x, y) { return (x.r || 99) - (y.r || 99); });

    var hatG = {}; D.geraete.forEach(function (g) { hatG[g.h] = true; });
    Object.keys(K.GERAETE).forEach(function (mk) {
      K.GERAETE[mk].forEach(function (g) {
        var ab = null;
        Object.keys(g.p).forEach(function (ah) {
          if (ah === 'kostenvoranschlag' || ah === 'wertgutachten') return;
          var pp = g.p[ah];
          if (typeof pp.p === 'number') {
            (D.preise[g.h] = D.preise[g.h] || {});
            if (typeof D.preise[g.h][ah] !== 'number') D.preise[g.h][ah] = Math.round(pp.p * 100);
            if (ab === null || pp.p * 100 < ab) ab = pp.p * 100;
          }
          if (typeof pp.o === 'number') {
            var zo = (D.preiseOriginal[g.h] = D.preiseOriginal[g.h] || {});
            if (typeof zo[ah] !== 'number') zo[ah] = Math.round(pp.o * 100);
          }
        });
        if (!hatG[g.h]) D.geraete.push({ h: g.h, n: g.n, t: TYP[mk], m: MARKE[mk], mn: mk === 'MacBook' ? 'MacBook' : '', ab: ab || 0, f: FAM[mk], lager: g.lager !== false });
      });
    });
  })();



  /* Zusaetzliche Geraete-Zeichnungen (eigene Illustrationen): Pixel, iPad, Android-Tablet, Typ-Symbol Tablet. */
  (function sprite() {
    if (document.getElementById('kfg-sprite-plus')) return;
    var x = '<svg id="kfg-sprite-plus" width="0" height="0" style="position:absolute" aria-hidden="true" focusable="false">' +
      '<symbol id="kfg-watch" viewBox="0 0 24 24"><rect x="6.5" y="6" width="11" height="12" rx="3"/><path d="M9 6l.7-3.5h4.6L15 6M9 18l.7 3.5h4.6L15 18M17.5 10.5h1"/></symbol>' +
      '<symbol id="kfg-fam-watch" viewBox="0 0 96 96"><defs><linearGradient id="kfgG11" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#d9e6ff"/><stop offset="1" stop-color="#5b7fd6"/></linearGradient></defs><path d="M36 6h24l3 16H33z" fill="#3a3f48"/><path d="M33 74h30l-3 16H36z" fill="#3a3f48"/><rect x="26" y="20" width="44" height="56" rx="12" fill="#22252b"/><rect x="30" y="24" width="36" height="48" rx="9" fill="url(#kfgG11)"/><rect x="70" y="36" width="4" height="10" rx="2" fill="#6b6f78"/></symbol>' +
      '<symbol id="kfg-tablet" viewBox="0 0 24 24"><rect x="3.5" y="2.5" width="17" height="19" rx="2.5"/><path d="M10.5 18.6h3"/></symbol>' +
      '<symbol id="kfg-fam-pixel" viewBox="0 0 96 96"><defs><linearGradient id="kfgG8" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#e8f0ff"/><stop offset="1" stop-color="#7aa7f0"/></linearGradient></defs><rect x="24" y="4" width="48" height="88" rx="9" fill="#2b2f36"/><rect x="27" y="7" width="42" height="82" rx="7" fill="url(#kfgG8)"/><circle cx="48" cy="12.5" r="2.2" fill="#14161a"/></symbol>' +
      '<symbol id="kfg-fam-ipad" viewBox="0 0 96 96"><defs><linearGradient id="kfgG9" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#ffd9c2"/><stop offset="1" stop-color="#f08a5d"/></linearGradient></defs><rect x="12" y="10" width="72" height="76" rx="8" fill="#c9ccd3"/><rect x="16" y="14" width="64" height="68" rx="4.5" fill="url(#kfgG9)"/><circle cx="48" cy="11.8" r="1" fill="#6b6f78"/></symbol>' +
      '<symbol id="kfg-fam-tablet" viewBox="0 0 96 96"><defs><linearGradient id="kfgG10" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#bfe3f2"/><stop offset="1" stop-color="#3f8fb5"/></linearGradient></defs><rect x="8" y="14" width="80" height="68" rx="7" fill="#22252b"/><rect x="12" y="18" width="72" height="60" rx="3.5" fill="url(#kfgG10)"/><circle cx="10.2" cy="48" r="1" fill="#0b0b0c"/></symbol>' +
      '</svg>';
    var d = document.createElement('div'); d.innerHTML = x; document.body.appendChild(d.firstChild);
  })();

  /* Preis-Daten (Spiegel der Preisliste, alle Marken): assets/as-preis-daten.js.
     Eintrag je Reparatur: [Premium/Standard, Original/Service Pack, Budget, ab-Hinweis].
     Diese Preise gelten vor Katalog und Metaobjekten. */
  D.preiseBudget = {}; D.preiseAb = {}; D.fest = {};
  (function preisDaten() {
    var P = window.AsPreisDaten;
    if (!P || !P.M) return;
    var tabletName = function (n) { return /^ipad|^galaxy tab|^galaxy view|pad/i.test(n); };
    P.G = [];
    Object.keys(P.M).forEach(function (mk) {
      P.M[mk].forEach(function (r) {
        var pr = {}; Object.keys(r[2]).forEach(function (c) { pr[P.A[c]] = r[2][c]; });
        P.G.push([r[0], r[1], mk, /watch/i.test(r[1]) ? 'Smartwatch' : tabletName(r[1]) ? 'Tablet' : 'Smartphone', pr]);
      });
    });
    var FAMN = function (n, t, m) {
      var l = n.toLowerCase();
      if (t === 'Smartwatch') return 'watch';
      if (t === 'Tablet') return /ipad/.test(l) ? 'ipad' : 'tablet';
      if (m === 'Apple') return /pro|max/.test(l) ? 'iphone-pro' : 'iphone';
      if (m === 'Samsung') return /galaxy a|galaxy m|galaxy j|xcover/.test(l) ? 'galaxy-a' : 'galaxy-s';
      if (m === 'Google') return 'pixel';
      if (m === 'Xiaomi') return 'xiaomi';
      return 'phone';
    };
    var have = {}; D.hersteller.forEach(function (x) { have[x.h] = true; });
    ['Apple', 'Samsung', 'Google', 'Xiaomi', 'Huawei', 'Motorola', 'OnePlus'].forEach(function (mn) { if (!have[mn.toLowerCase()] && P.M[mn] && P.M[mn].length) D.hersteller.push({ h: mn.toLowerCase(), n: mn }); });
    var hatT = {}; D.typen.forEach(function (t) { hatT[t.k] = true; });
    if (!hatT.Smartphone) D.typen.push({ k: 'Smartphone', l: 'Smartphone', s: 'Apple, Samsung, Google, Xiaomi', i: 'smartphone' });
    if (!hatT.Tablet) D.typen.push({ k: 'Tablet', l: 'Tablet', s: 'iPad, Galaxy Tab, Xiaomi Pad', i: 'tablet' });
    if (!hatT.Smartwatch && P.G.some(function (g) { return g[3] === 'Smartwatch'; })) D.typen.push({ k: 'Smartwatch', l: 'Smartwatch', s: 'Apple Watch, Galaxy Watch', i: 'watch' });
    function nk(n) { return String(n).toLowerCase().replace(/\([^)]*\)/g, '').replace(/\b[45]g\b/g, '').replace(/[^a-z0-9+]/g, ''); }
    var namen = {}; P.G.forEach(function (g) { namen[nk(g[1])] = g[0]; });
    D.geraete = D.geraete.filter(function (x) { var k = nk(x.n); return !(namen[k] && namen[k] !== x.h); });
    var bestehend = {}; D.geraete.forEach(function (x) { bestehend[x.h] = x; });
    P.G.forEach(function (g) {
      var h = g[0], pr = g[4], ab = null, pp = {}, po = {}, pb = {}, pa = {};
      Object.keys(P.C || {}).forEach(function (a) { if (!pr[a]) pr[a] = [P.C[a], null, null, 1]; });
      Object.keys(pr).forEach(function (a) {
        var e = pr[a];
        if (e[0] != null) pp[a] = e[0] * 100;
        if (e[1] != null) po[a] = e[1] * 100;
        if (e[2] != null) pb[a] = e[2] * 100;
        if (e[3]) pa[a] = true;
        e.slice(0, 3).forEach(function (v) { if (v != null && (ab === null || v * 100 < ab)) ab = v * 100; });
      });
      D.preise[h] = pp; D.preiseOriginal[h] = po; D.preiseBudget[h] = pb; D.preiseAb[h] = pa; D.fest[h] = true;
      var g0 = bestehend[h];
      if (g0) { g0.n = g[1]; g0.t = g[3]; g0.m = g[2].toLowerCase(); g0.ab = ab || 0; g0.f = FAMN(g[1], g[3], g[2]); g0.lager = true; }
      else D.geraete.push({ h: h, n: g[1], t: g[3], m: g[2].toLowerCase(), mn: '', ab: ab || 0, f: FAMN(g[1], g[3], g[2]), lager: true });
    });
  })();

  /* Was im Theme unter "Reparaturen ausblenden" steht, faellt hier raus.
     Verglichen wird der sichtbare Name, damit niemand Handles kennen muss. */
  (function ausblenden() {
    function liste(x) { var o = {}; (x || []).forEach(function (n) { n = String(n).trim().toLowerCase(); if (n) o[n] = true; }); return o; }
    var ausA = liste(D.artenAus), ausG = liste(D.geraeteAus);
    var hA = liste(D.artenInaktiv), hG = liste(D.geraeteInaktiv);
    D.arten = D.arten.filter(function (a) {
      return !ausA[String(a.n).trim().toLowerCase()] && !hA[String(a.h).trim().toLowerCase()];
    });
    D.geraete = D.geraete.filter(function (g) {
      return !ausG[String(g.n).trim().toLowerCase()] && !hG[String(g.h).trim().toLowerCase()];
    });
    /* Die Listen bleiben erreichbar: Produkte, die später nachgeladen werden,
       dürfen nichts wieder einblenden, was hier ausgeblendet wurde. */
    D.versteckt = { artName: ausA, artHandle: hA, geraetName: ausG, geraetHandle: hG };
  })();

  window.AsKfgDaten = D;

  /* ---------- Produkte als Preisquelle ----------
     Jedes Geraet ist ein Shopify-Produkt (Typ "Reparatur"), jede Reparatur eine Variante.
     Was dort steht, gilt: Preise, Verfuegbarkeit, Kaufbarkeit. Katalog und Metaobjekte
     bleiben nur als Rueckfallebene, falls der Abruf scheitert. SKU-Schema:
     REP-<geraet>-<art>-<P|O>. Abgerufen wird pro Marke, sobald sie gewaehlt ist. */
  D.varianten = D.varianten || {};
  D.versandFreiAb = typeof D.versandFreiAb === 'number' ? D.versandFreiAb : 0;
  var produktCache = {}, produktFertig = {};
  function sammlungFuer(typ, marke) { return 'reparatur-' + (typ === 'Laptop' ? 'macbook' : (marke || 'apple')); }
  function skuLesen(sku) {
    var t = String(sku || '').split('-');
    if (t.length < 4 || t[0] !== 'REP') return null;
    var q = t.pop(), art = t.pop(); t.shift();
    return { gh: t.join('-'), art: art, q: q === 'O' ? 'o' : (q === 'B' ? 'b' : 'p') };
  }
  function produktEinmischen(pr) {
    var tags = pr.tags || [], gh = null, typ = 'Smartphone', fam = 'phone', marke = (pr.vendor || '').toLowerCase();
    tags.forEach(function (t) {
      if (t.indexOf('geraet:') === 0) gh = t.slice(7);
      if (t.indexOf('typ:') === 0) typ = t.slice(4);
      if (t.indexOf('fam:') === 0) fam = t.slice(4);
      if (t.indexOf('marke:') === 0) marke = t.slice(6);
    });
    if (!gh) return;
    var name = String(pr.title || '').replace(/\s+Reparatur\s*$/i, '');
    var V = D.versteckt || { artName: {}, artHandle: {}, geraetName: {}, geraetHandle: {} };
    /* Im Theme oder per Metaobjekt ausgeblendet? Dann bleibt das Produkt draußen. */
    if (V.geraetHandle[gh] || V.geraetName[name.trim().toLowerCase()]) return;
    var g = D.geraete.filter(function (x) { return x.h === gh; })[0];
    if (!g) { g = { h: gh, n: name, t: typ, m: marke, mn: typ === 'Laptop' ? 'MacBook' : '', ab: 0, f: fam, img: null }; D.geraete.push(g); }
    g.produkt = pr.handle; g.n = name || g.n;
    if (!g.img && pr.images && pr.images[0]) g.img = pr.images[0].src;
    var fest = !!D.fest[gh];
    if (!fest) { D.preise[gh] = {}; D.preiseOriginal[gh] = {}; }
    D.varianten[gh] = {};
    var ab = null;
    (pr.variants || []).forEach(function (v) {
      var k = skuLesen(v.sku); if (!k || k.gh !== gh) return;
      var vn = String(v.option1 || v.title || '').replace(/\s+[–-]\s+(Premiumteil|Originalteil|Standardteil|Budgetteil)$/, '').trim().toLowerCase();
      if (V.artHandle[k.art] || V.artName[vn]) return;
      /* Ausverkauft (Bestand verfolgt, 0 Stück) = wird für dieses Gerät nicht angeboten. */
      if (v.available === false) return;
      var cent = Math.round(parseFloat(v.price) * 100);
      if (!(cent > 0)) return;
      if (fest) { var soll = ((k.q === 'o' ? D.preiseOriginal[gh] : k.q === 'b' ? D.preiseBudget[gh] : D.preise[gh]) || {})[k.art]; if (soll !== cent) return; }
      else if (k.q === 'o') D.preiseOriginal[gh][k.art] = cent; else if (k.q === 'b') (D.preiseBudget[gh] = D.preiseBudget[gh] || {})[k.art] = cent; else D.preise[gh][k.art] = cent;
      (D.varianten[gh][k.art] = D.varianten[gh][k.art] || {})[k.q] = v.id;
      if (v.available !== false && (ab === null || cent < ab)) ab = cent;
    });
    if (!fest) g.ab = ab || 0;
    /* Reparaturarten, die nur im Produkt stehen, bekommen einen Eintrag – sonst fehlt der Name. */
    Object.keys(D.preise[gh]).forEach(function (ah) {
      if (D.arten.some(function (a) { return a.h === ah; })) return;
      var vn = (pr.variants || []).filter(function (v) { var k = skuLesen(v.sku); return k && k.art === ah; })[0];
      var n = vn ? String(vn.option1 || vn.title).replace(/\s+[–-]\s+(Premiumteil|Originalteil|Standardteil|Budgetteil)$/, '') : ah;
      D.arten.push({ h: ah, n: n, d: '', min: 0, gar: 12, i: 'werkzeug', typen: [], r: 99 });
    });
  }
  function ladeProdukte(typ, marke) {
    var slug = sammlungFuer(typ, marke);
    if (produktCache[slug]) return produktCache[slug];
    produktCache[slug] = new Promise(function (ok) {
      if (!window.fetch) return ok(false);
      fetch('/collections/' + slug + '/products.json?limit=250', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          if (!j || !j.products) return ok(false);
          j.products.forEach(produktEinmischen);
          produktFertig[slug] = true;
          ok(true);
        })
        .catch(function () { ok(false); });
    });
    return produktCache[slug];
  }
  function varianteFuer(gh, ah) {
    var v = D.varianten[gh] && D.varianten[gh][ah];
    if (!v) return null;
    /* Genau die Qualitaet kaufen, die angezeigt wird: Standard (SKU -B), Premium (-P), Original (-O). */
    var q = qEff(gh, ah);
    if (q === 'o' && v.o) return v.o;
    if (q === 'b' && v.b) return v.b;
    return v.p || v.b || v.o || null;
  }
  /* Express-Aufpreis: eigenes Produkt "express-reparatur" (SKU REP-EXPRESS, kein Versand).
     Nur beim Einschicken waehlbar; landet zusammen mit der Reparatur im Warenkorb. */
  var EXPRESS = { id: D.expressVariante || 55347421118807, preis: typeof D.expressPreis === 'number' ? D.expressPreis : 2900 };
  /* Extras (01.11.2026): Panzerglas Standard/Privacy und Kamera-Schutzglas, je inkl. Anbringen.
     Eigene Service-Produkte (SKU REP-PANZERGLAS, REP-PANZERGLAS-PRIVACY, REP-KAMERASCHUTZ).
     Nur bei Smartphones, nur beim Einschicken und nur wenn die Reparatur direkt kaufbar ist. */
  var EXTRAS = [
    { k: 'pg', g: 'pg', t: 'Panzerglas inkl. Anbringen', q: 'Standard', s: 'Klares 9H-Glas, passgenau und blasenfrei angebracht', ico: 'schild', id: 55690070720855, preis: 1990 },
    { k: 'pgp', g: 'pg', t: 'Panzerglas inkl. Anbringen', q: 'Privacy', s: 'Mit Sichtschutz – von der Seite schwarz, nur du siehst den Bildschirm', ico: 'schild', id: 55690072752471, preis: 2490 },
    { k: 'kam', g: 'kam', t: 'Kamera-Schutzglas inkl. Anbringen', q: '', s: 'Schützt die Linsen der Rückkamera vor Kratzern und Bruch', ico: 'kamera', id: 55690072785239, preis: 1490 }
  ];
  function extrasMoeglich() { return S.weg === 'versand' && !!S.geraet && S.geraet.t === 'Smartphone' && allesKaufbar(); }
  function extrasGewaehlt() { return extrasMoeglich() ? EXTRAS.filter(function (x) { return !!S.extras[x.k]; }) : []; }
  function extraName(x) { return x.t + (x.q ? ' · ' + x.q : ''); }
  function allesKaufbar() {
    if (!S.geraet || S.geraet.h === '__unbekannt__' || !S.arten.length) return false;
    return S.arten.every(function (ah) { return !!varianteFuer(S.geraet.h, ah); });
  }

  var fab     = document.querySelector('[data-kfg-fab]');
  var elClose = root ? root.querySelector('[data-kfg-close]') : (drawer || inline).querySelector('[data-kfg-close]');
  var elBody  = root ? root.querySelector('[data-kfg-body]') : null;
  var elTitle = root ? root.querySelector('[data-kfg-title]') : null;
  var elBack  = root ? root.querySelector('[data-kfg-back]') : null;
  var elFoot  = root ? root.querySelector('[data-kfg-foot]') : null;
  var elSum   = root ? root.querySelector('[data-kfg-sum]') : null;
  var elSumL  = root ? root.querySelector('[data-kfg-sum-label]') : null;
  var elNext  = root ? root.querySelector('[data-kfg-next]') : null;
  var elDots  = root ? root.querySelector('[data-kfg-dots]') : null;
  var form    = document.getElementById('AsKfgForm');

  var S = { typ: null, marke: null, geraet: null, arten: [], qual: {}, weg: null, adresse: {}, datum: null, zeit: null, kontakt: {}, monat: null, ok: false, details: {}, express: false, extras: {} };
  var FLOW = ['typ', 'marke', 'modell', 'reparatur', 'weg', 'termin', 'kasse', 'kontakt'];
  var idx = 0, gezeichnet = false, letzterFokus = null;

  var TITEL = { typ: 'Wähle dein Gerät', marke: 'Wähle die Marke', modell: 'Wähle dein Modell', reparatur: 'Was ist kaputt?', weg: 'Versand oder vor Ort?', termin: 'Wunschtermin', kasse: 'Fast geschafft', kontakt: 'Fast fertig' };
  var TAGE = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
  var MONATE = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];

  function eur(c) { return (c / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); }
  function icon(key, cls) { return '<svg class="' + (cls || 'kfg-ico') + '" aria-hidden="true"><use href="#kfg-' + key + '"></use></svg>'; }
  function bild(g, cls) {
        return '<svg class="' + (cls || 'kfg-bild') + '" aria-hidden="true"><use href="#kfg-fam-' + esc(g.f || 'phone') + '"></use></svg>';
  }
  function dauer(min) {
    if (!min) return '';
    if (min >= 1440) return 'ca. 1 Tag';
    if (min >= 60) { var h = min / 60; return 'ca. ' + (h % 1 === 0 ? h : h.toFixed(1).replace('.', ',')) + ' Std.'; }
    return 'ca. ' + min + ' Min.';
  }
  function geraeteFuer(typ, marke) { return D.geraete.filter(function (g) { return (!typ || g.t === typ) && (!marke || g.m === marke); }); }
  var MARKEN_REIHE = ['apple', 'samsung', 'google', 'xiaomi', 'huawei', 'motorola', 'oneplus'];
  function markenFuer(typ) { var da = {}; geraeteFuer(typ, null).forEach(function (g) { da[g.m] = true; }); var rk = function (m) { var i = MARKEN_REIHE.indexOf(m.h); return i === -1 ? 99 : i; }; return D.hersteller.filter(function (m) { return da[m.h]; }).sort(function (a, b) { return rk(a) - rk(b); }); }
  /* Standardpreis aus der Reparaturart: greift, wenn es fuer dieses Geraet keinen
     eigenen Preis-Eintrag gibt. So reicht ein Eintrag fuer alle Modelle. */
  function standard(ah, orig) {
    var a = D.arten.filter(function (x) { return x.h === ah; })[0];
    if (!a) return null;
    var w = orig ? a.so : a.sp;
    return typeof w === 'number' && w > 0 ? w : null;
  }
  var QN = { p: 'Premiumteil', o: 'Originalteil', b: 'Standardteil' };
  function tierPreis(gh, ah, q) {
    var m = q === 'o' ? D.preiseOriginal : q === 'b' ? D.preiseBudget : D.preise;
    var p = m && m[gh];
    if (p && typeof p[ah] === 'number') return p[ah];
    if (D.fest[gh]) return null;
    if (q === 'p') return standard(ah, false);
    if (q === 'o') return standard(ah, true);
    return null;
  }
  function qualListe(gh, ah) { return ['b', 'p', 'o'].filter(function (q) { return tierPreis(gh, ah, q) !== null; }).sort(function (x, y) { return tierPreis(gh, ah, x) - tierPreis(gh, ah, y); }); }
  function qEff(gh, ah) { var l = qualListe(gh, ah); return l.indexOf(S.qual[ah]) !== -1 ? S.qual[ah] : (l.indexOf('p') !== -1 ? 'p' : (l[0] || 'p')); }
  function hatQual(gh, ah) { return qualListe(gh, ah).length > 1; }
  function origPreis(gh, ah) { return tierPreis(gh, ah, 'o'); }
  function preisFuer(gh, ah) { return qualListe(gh, ah).length ? tierPreis(gh, ah, qEff(gh, ah)) : null; }
  function istAb(gh, ah) { return !!(D.preiseAb[gh] && D.preiseAb[gh][ah]); }
  function qualName(ah) { var gh = S.geraet && S.geraet.h, q = qEff(gh, ah); if (ah === 'akku') return q === 'o' ? 'Service Pack' : (q === 'b' ? 'Standard' : 'Premium'); return QN[q]; }
  function artenFuerGeraet() {
    if (!S.geraet || S.geraet.h === '__unbekannt__') return D.arten;
    return D.arten.filter(function (a) { return a.typen.length === 0 || a.typen.indexOf(S.geraet.t) !== -1; });
  }
  function summe() {
    var bekannt = 0, offen = 0;
    S.arten.forEach(function (h) { var p = S.geraet ? preisFuer(S.geraet.h, h) : null; if (p === null) offen++; else bekannt += p; });
    var versand = 0;
    if (S.weg === 'versand' && D.versandpreis > 0 && !(D.versandFreiAb > 0 && bekannt >= D.versandFreiAb)) versand = D.versandpreis;
    var express = S.weg === 'versand' && S.express ? EXPRESS.preis : 0;
    var extra = extrasGewaehlt().reduce(function (a, x) { return a + x.preis; }, 0);
    return { betrag: bekannt + versand + express + extra, offen: offen, versand: versand, waren: bekannt, express: express, extra: extra };
  }
  var SONST_H = '__sonstiges__', SONST_N = 'Weitere Reparatur (Preis auf Anfrage)';
  function artName(h) { if (h === SONST_H) return SONST_N; var a = D.arten.filter(function (x) { return x.h === h; })[0]; return a ? a.n : h; }
  function terminText() { var d = new Date(S.datum + 'T00:00:00'); return TAGE[d.getDay()] + ', ' + d.getDate() + '. ' + MONATE[d.getMonth()] + ' ' + d.getFullYear() + ', ' + S.zeit + ' Uhr'; }
  function preisText(s) { return s.offen > 0 && s.betrag === 0 ? 'auf Anfrage' : eur(s.betrag) + (s.offen > 0 ? ' zzgl. offener Positionen' : ''); }
  function whatsappUrl() {
    if (!D.whatsapp) return '';
    var s = summe();
    var txt = 'Hallo AS-Electronics, ich möchte reparieren lassen:\n' + (S.geraet ? S.geraet.n : '') + ' – ' + S.arten.map(artName).join(', ') +
      '\nPreis laut Preis-Check: ' + preisText(s) + (S.weg ? '\nWeg: ' + (S.weg === 'vorort' ? 'Vorbeibringen' : 'Einschicken' + (S.express ? ' + Express-Reparatur' : '')) : '');
    return 'https://wa.me/' + String(D.whatsapp).replace(/\D/g, '') + '?text=' + encodeURIComponent(txt);
  }

  /* ---------- Drawer ---------- */
  var scrollMerker = 0;
  function sperreSeite() {
    scrollMerker = window.scrollY || window.pageYOffset || 0;
    document.body.style.top = (-scrollMerker) + 'px';
    document.body.classList.add('as-kfg-open');
  }
  function entsperreSeite() {
    document.body.classList.remove('as-kfg-open');
    document.body.style.top = '';
    window.scrollTo(0, scrollMerker);
  }
  function oeffne(ausloeser) {
    if (inline) {
      if (root && !gezeichnet) { zeichne(); gezeichnet = true; }
      if (ausloeser) inline.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    letzterFokus = ausloeser || document.activeElement;
    drawer.hidden = false;
    requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    sperreSeite();
    if (fab) fab.setAttribute('aria-hidden', 'true');
    if (root && !gezeichnet) { zeichne(); gezeichnet = true; }
    setTimeout(function () { try { elClose.focus({ preventScroll: true }); } catch (e) {} }, 60);
  }
  function schliesse() {
    if (inline) return;
    drawer.classList.remove('is-open');
    entsperreSeite();
    if (fab) fab.removeAttribute('aria-hidden');
    setTimeout(function () { drawer.hidden = true; }, 260);
    if (letzterFokus && letzterFokus.focus) { try { letzterFokus.focus({ preventScroll: true }); } catch (e) {} }
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-kfg-open], a[href="#konfigurator"], a[href$="#konfigurator"]');
    if (!t) return;
    e.preventDefault();
    var g = t.getAttribute('data-kfg-geraet'), r = t.getAttribute('data-kfg-reparatur'), ty = t.getAttribute('data-kfg-typ');
    if (g || ty) window.AsKfg.open({ geraet: g, reparatur: r, typ: ty }, t); else oeffne(t);
  });
  if (elClose) elClose.addEventListener('click', schliesse);
  if (drawer) {
    drawer.querySelector('[data-kfg-backdrop]').addEventListener('click', schliesse);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) schliesse(); });
  }

  /* ---------- Navigation ---------- */
  /* Einschicken + alles kaufbar -> Kasse (echter Kauf). Sonst -> Anfrage per Formular.
     Termin nur bei Abgabe vor Ort. */
  function sichtbareSchritte() {
    var kauf = S.weg === 'versand' && allesKaufbar();
    return FLOW.filter(function (s) {
      if (s === 'termin') return S.weg === 'vorort';
      if (s === 'kasse') return kauf;
      if (s === 'kontakt') return !kauf;
      return true;
    });
  }
  function gehe(zu) {
    var liste = sichtbareSchritte(), aktuell = FLOW[idx], pos = liste.indexOf(aktuell);
    if (typeof zu === 'string') pos = liste.indexOf(zu); else pos = zu;
    pos = Math.max(0, Math.min(liste.length - 1, pos));
    idx = FLOW.indexOf(liste[pos]); zeichne();
    zumSchrittAnfang();
  }
  /* Nach jedem Schrittwechsel den Anfang des neuen Schritts zeigen. Inline (Preis-Check-Seite)
     scrollt sonst die Seite nicht mit: der neue Schritt ist oft kuerzer, der Browser haelt die
     klebende Fussleiste fest und man landet unten. Modal: eigenen Scroll-Bereich nach oben. */
  function zumSchrittAnfang() {
    if (!root) return;
    var fokusDrin = !document.activeElement || document.activeElement === document.body || root.contains(document.activeElement);
    if (elTitle && fokusDrin) {
      if (!elTitle.hasAttribute('tabindex')) elTitle.setAttribute('tabindex', '-1');
      try { elTitle.focus({ preventScroll: true }); } catch (e) {}
    }
    if (!inline) { elBody.scrollTop = 0; return; }
    var leise = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    requestAnimationFrame(function () {
      var kopf = document.querySelector('.as-hd'), versatz = 0;
      if (kopf) {
        var pos = window.getComputedStyle(kopf).position;
        if (pos === 'sticky' || pos === 'fixed') versatz = kopf.offsetHeight;
      }
      versatz += 12;
      var oben = inline.getBoundingClientRect().top;
      if (oben < versatz || oben > window.innerHeight - 120) {
        var ziel = Math.max(0, oben + (window.pageYOffset || document.documentElement.scrollTop || 0) - versatz);
        try { window.scrollTo({ top: ziel, behavior: leise ? 'auto' : 'smooth' }); } catch (e) { window.scrollTo(0, ziel); }
      }
    });
  }
  function weiter() { var liste = sichtbareSchritte(); gehe(liste.indexOf(FLOW[idx]) + 1); }
  function zurueck() { var liste = sichtbareSchritte(), pos = liste.indexOf(FLOW[idx]); if (pos <= 0) return; gehe(pos - 1); }

  function zeichne() {
    if (!root) return;
    var schritt = FLOW[idx];
    elTitle.textContent = TITEL[schritt];
    elBack.hidden = idx === 0;
    var liste = sichtbareSchritte(), pos = liste.indexOf(schritt);
    elDots.innerHTML = liste.map(function (s, i) { return '<span class="kfg-dot' + (i <= pos ? ' is-on' : '') + '"></span>'; }).join('');
    elDots.setAttribute('aria-label', 'Schritt ' + (pos + 1) + ' von ' + liste.length);
    ({ typ: schrittTyp, marke: schrittMarke, modell: schrittModell, reparatur: schrittReparatur, weg: schrittWeg, termin: schrittTermin, kasse: schrittKasse, kontakt: schrittKontakt })[schritt]();
    elBody.scrollTop = 0;
    elBody.classList.remove('is-neu'); void elBody.offsetWidth; elBody.classList.add('is-neu');
  }
  function fussLeiste(zeigen, aktiv, label) {
    elFoot.hidden = !zeigen;
    if (!zeigen) return;
    var s = summe();
    elSumL.textContent = s.offen > 0 && s.betrag > 0 ? 'Festpreis ab' : (s.offen > 0 ? 'Preis' : (s.versand > 0 ? 'Gesamt inkl. Versand' : 'Festpreis'));
    elSum.textContent = s.offen > 0 && s.betrag === 0 ? 'auf Anfrage' : eur(s.betrag);
    elNext.disabled = !aktiv;
    elNext.querySelector('span').textContent = label || 'Weiter';
    /* Im letzten Schritt ist der Knopf der echte Absende-Knopf des Kontaktformulars.
       Nur ein solcher Knopf laesst Shopifys Spamschutz den Token setzen. */
    var letzter = FLOW[idx] === 'kontakt' && form;
    if (letzter) { elNext.type = 'submit'; elNext.setAttribute('form', form.id || 'AsKfgForm'); }
    else { elNext.type = 'button'; elNext.removeAttribute('form'); }
  }

  /* ---------- Schritte ---------- */
  function schrittTyp() {
    fussLeiste(false);
    elBody.innerHTML = '<div class="kfg-kacheln">' + D.typen.map(function (t) {
      return '<button type="button" class="kfg-kachel" data-typ="' + esc(t.k) + '">' + icon(t.i, 'kfg-ico kfg-ico--gross') + '<span class="kfg-kachel__t">' + esc(t.l) + '</span><span class="kfg-kachel__s">' + esc(t.s) + '</span></button>';
    }).join('') + '</div>';
    elBody.querySelectorAll('[data-typ]').forEach(function (b) { b.addEventListener('click', function () { if (S.typ !== b.dataset.typ) { S.marke = null; S.geraet = null; S.arten = []; } S.typ = b.dataset.typ; weiter(); }); });
  }
  function schrittMarke() {
    fussLeiste(false);
    elBody.innerHTML = '<div class="kfg-kacheln kfg-kacheln--2">' + markenFuer(S.typ).map(function (m) {
      var g = geraeteFuer(S.typ, m.h);
      return '<button type="button" class="kfg-kachel kfg-kachel--marke" data-marke="' + esc(m.h) + '">' + bild(g[0] || {}, 'kfg-bild kfg-bild--marke') + '<span class="kfg-marke__n">' + esc(m.n) + '</span><span class="kfg-kachel__s">' + g.length + ' Modelle</span></button>';
    }).join('') + '</div>';
    elBody.querySelectorAll('[data-marke]').forEach(function (b) { b.addEventListener('click', function () { if (S.marke !== b.dataset.marke) { S.geraet = null; S.arten = []; } S.marke = b.dataset.marke; ladeProdukte(S.typ, S.marke); weiter(); }); });
  }
  function schrittModell() {
    fussLeiste(false);
    /* Neueste Modelle zuerst – so sucht der Kunde, und so machen es die großen Anbieter. */
    function sortiert() {
      var l = geraeteFuer(S.typ, S.marke).slice(), K = window.AsReparaturKatalog;
      if (S.typ === 'Smartwatch') return l; if (S.typ === 'Tablet') return K && K.tabletSort ? K.tabletSort(l.map(function (g) { return [0, g.n, g]; })).map(function (a) { return a[2]; }) : l; if (S.marke === 'google' || S.marke === 'xiaomi') return l;
      return K && K.sortiere ? K.sortiere(l, function (g) { return g.n; }, function (g) { return g.f; }) : l;
    }
    var liste = sortiert();
    elBody.innerHTML = '<label class="kfg-suche">' + icon('suche', 'kfg-ico kfg-ico--klein') + '<input type="search" placeholder="Modell suchen" autocomplete="off" data-kfg-suche aria-label="Modell suchen"></label>' +
      '<div class="kfg-zeilen" data-liste></div><p class="kfg-hinweis" data-leer hidden>Kein Treffer. Wähle unten „Mein Modell ist nicht dabei“.</p>' +
      '<button type="button" class="kfg-zeile kfg-zeile--unbekannt" data-unbekannt><span class="kfg-zeile__bild">' + icon('frage') + '</span><span class="kfg-zeile__t">Mein Modell ist nicht dabei</span>' + icon('pfeil', 'kfg-ico kfg-ico--klein kfg-pfeil') + '</button>';
    var ziel = elBody.querySelector('[data-liste]'), leer = elBody.querySelector('[data-leer]');
    function male(q) {
      var AL = { 'iPad (2025)': 'a16 11. generation a3354 a3355 a3356', 'iPad (2022)': 'a14 10. generation 10.9', 'iPad 10.2 (2021)': 'a13 9. generation', 'iPad 10.2 (2020)': 'a12 8. generation', 'iPad 10.2 (2019)': '7. generation', 'iPad 9.7 (2018)': '6. generation', 'iPad 9.7 (2017)': '5. generation', 'iPad mini (2024)': 'mini 7 a17 pro', 'iPad mini (2021)': 'mini 6 a15', 'iPad mini (2019)': 'mini 5 a12', 'iPad Air 13 (2025)': 'm3', 'iPad Air 11 (2025)': 'm3', 'iPad Air 13 (2024)': 'm2', 'iPad Air 11 (2024)': 'm2', 'iPad Air (2022)': 'air 5 m1', 'iPad Air (2020)': 'air 4 a14', 'iPad Air (2019)': 'air 3 a12', 'iPad Pro 13 (2025)': 'm5', 'iPad Pro 11 (2025)': 'm5', 'iPad Pro 13 (2024)': 'm4', 'iPad Pro 11 (2024)': 'm4', 'iPad Pro 12.9 (2022)': 'm2', 'iPad Pro 11 (2022)': 'm2', 'iPad Pro 12.9 (2021)': 'm1', 'iPad Pro 11 (2021)': 'm1' }; var woerter = String(q || '').split(/\s+/).filter(Boolean); var gef = liste.filter(function (g) { var t = (g.n + ' ' + g.mn + ' ' + (AL[g.n] || '')).toLowerCase(); return !woerter.length || woerter.every(function (w) { return t.indexOf(w) !== -1; }); });
      leer.hidden = gef.length > 0;
      ziel.innerHTML = gef.map(function (g) {
        var ab = g.ab ? '<span class="kfg-zeile__p">ab ' + eur(g.ab) + '</span>' : '<span class="kfg-zeile__p kfg-zeile__p--leise">auf Anfrage</span>';
        return '<button type="button" class="kfg-zeile" data-geraet="' + esc(g.h) + '"><span class="kfg-zeile__bild">' + bild(g) + '</span><span class="kfg-zeile__t">' + esc(g.n) + '</span>' + ab + icon('pfeil', 'kfg-ico kfg-ico--klein kfg-pfeil') + '</button>';
      }).join('');
      ziel.querySelectorAll('[data-geraet]').forEach(function (b) { b.addEventListener('click', function () { var g = liste.filter(function (x) { return x.h === b.dataset.geraet; })[0]; if (S.geraet && S.geraet.h !== g.h) S.arten = []; S.geraet = g; weiter(); }); });
    }
    male('');
    var feld = elBody.querySelector('[data-kfg-suche]');
    feld.addEventListener('input', function () { male(feld.value.trim().toLowerCase()); });
    var geladenVorher = !!produktCache[sammlungFuer(S.typ, S.marke)] && produktFertig[sammlungFuer(S.typ, S.marke)];
    if (!geladenVorher) ladeProdukte(S.typ, S.marke).then(function () { if (FLOW[idx] === 'modell') { liste = sortiert(); male(feld.value.trim().toLowerCase()); } });
    elBody.querySelector('[data-unbekannt]').addEventListener('click', function () { S.geraet = { h: '__unbekannt__', n: 'Modell unbekannt', t: S.typ, mn: '', ab: 0, f: S.typ === 'Laptop' ? 'macbook' : 'phone' }; S.arten = []; weiter(); });
  }
  /* Beschreibungen, die nur beim Smartphone stimmen. Ein MacBook hat keinen Touch. */
  var TXT_LAPTOP = {
    display: 'Gesprungen, dunkel oder mit Streifen im Bild',
    displayglas: 'Nur die Scheibe, das Panel bleibt',
    akku: 'Hält keinen Arbeitstag mehr oder schaltet ab',
    tastatur: 'Tasten haken, doppeln oder reagieren nicht',
    ladebuchse: 'Lädt nicht mehr zuverlässig',
    lautsprecher: 'Ton kratzt oder fällt aus',
    gehaeuserahmen: 'Deckel oder Unterschale verzogen',
    mittelrahmen: 'Scharnier oder Rahmen verzogen'
  };
  function artText(a) {
    if (S.geraet && S.geraet.t === 'Laptop' && TXT_LAPTOP[a.h]) return TXT_LAPTOP[a.h];
    return a.d;
  }

  function schrittReparatur() {
    var slug = sammlungFuer(S.typ, S.marke);
    if (S.geraet && S.geraet.h !== '__unbekannt__' && !produktFertig[slug] && !produktCache[slug + '#warte']) {
      produktCache[slug + '#warte'] = true;
      ladeProdukte(S.typ, S.marke).then(function () { if (FLOW[idx] === 'reparatur') schrittReparatur(); });
    }
    var arten = artenFuerGeraet();
    elBody.innerHTML = '<div class="kfg-geraet"><span class="kfg-geraet__bild">' + bild(S.geraet) + '</span><span><b>' + esc(S.geraet.n) + '</b><small>' + esc(S.geraet.mn || S.typ) + '</small></span><button type="button" class="kfg-aendern" data-aendern>Ändern</button></div>' +
      '<p class="kfg-hinweis">Mehrfachauswahl möglich – der Preis rechnet sich unten mit.</p>' +
      '<p class="kfg-hinweis kfg-hinweis--mobil">' + (arten[0] && arten[0].gar ? arten[0].gar + ' Monate Garantie · ' : '') + 'in 48 Std. repariert · Festpreis inkl. Teil und Einbau</p>' + optionenHtml();
    /* Reparaturen mit Festpreis werden gezeigt. Alles ohne Preis lief frueher als aufklappbare
       Liste mit bis zu 19 weiteren Kacheln – das wirkte wie ein Katalog und niemand hat sie
       durchgelesen. Stattdessen jetzt eine einzige Kachel: Schaden beschreiben, wir melden uns
       mit einem Festpreis. Die Namen der offenen Reparaturen stehen als Beispiele darunter. */
    function optionenHtml() {
      var gh = S.geraet.h, mit = [], ohne = [];
      arten.forEach(function (a) { (preisFuer(gh, a.h) === null ? ohne : mit).push(a); });
      var bsp = ohne.slice(0, 3).map(function (a) { return a.n; }).join(', ');
      var sonst = {
        h: SONST_H, n: 'Weitere Reparatur', i: 'werkzeug', typen: [],
        d: (bsp ? 'z. B. ' + bsp + '. ' : '') + 'Kurz beschreiben – Festpreis nennen wir vorab.'
      };
      return '<div class="kfg-optionen">' + mit.map(optionHtml).join('') + optionHtml(sonst) + '</div>';
    }
    function optionHtml(a) {
        var p = preisFuer(S.geraet.h, a.h), o = origPreis(S.geraet.h, a.h), an = S.arten.indexOf(a.h) !== -1, chips = '';
        /* Bei der Sammelkachel wissen wir weder Garantie noch Dauer – dann lieber nichts versprechen. */
        if (a.h !== SONST_H) {
          if (a.gar) chips += '<span class="kfg-chip">' + icon('schild', 'kfg-ico kfg-ico--mini') + a.gar + ' Monate Garantie</span>';
          chips += '<span class="kfg-chip">' + icon('uhr', 'kfg-ico kfg-ico--mini') + 'in 48 Std. repariert</span>';
        }
        var knopf = '<button type="button" class="kfg-option' + (an ? ' is-on' : '') + '" data-art="' + esc(a.h) + '" aria-pressed="' + an + '"><span class="kfg-check" aria-hidden="true">' + icon('haken', 'kfg-ico kfg-ico--mini') + '</span><span class="kfg-option__ico">' + icon(a.i || 'werkzeug') + '</span><span class="kfg-option__txt"><b>' + esc(a.n) + '</b>' + (function () { var t = artText(a); return t ? '<small>' + esc(t) + '</small>' : ''; })() + (chips ? '<span class="kfg-chips">' + chips + '</span>' : '') + '</span><span class="kfg-option__p' + (p === null ? ' kfg-option__p--leise' : '') + '" data-preis="' + esc(a.h) + '">' + (p === null ? 'Auf Anfrage' : ((istAb(S.geraet.h, a.h) || (hatQual(S.geraet.h, a.h) && !S.qual[a.h])) ? 'ab ' : '') + eur(p)) + '</span></button>';
        var qual = '';
        if (hatQual(S.geraet.h, a.h)) {
          var ist = qEff(S.geraet.h, a.h);
          var akku = a.h === 'akku', sub = { p: akku ? 'Hochwertiger Ersatzakku, geprüfte Qualität' : 'Geprüfte Qualität, in der Werkstatt bewährt', o: akku ? 'Original Service Pack vom Hersteller' : 'Vom Hersteller, alle Funktionen bleiben', b: 'Preiswerte Alternative mit 12 Monaten Garantie' };
          qual = '<div class="kfg-qual" data-qual-fuer="' + esc(a.h) + '"' + (an ? '' : ' hidden') + '>' + qualListe(S.geraet.h, a.h).map(function (q) {
            var nm = akku ? (q === 'o' ? 'Service Pack' : (q === 'b' ? 'Standard' : 'Premium')) : QN[q];
            return '<button type="button" class="kfg-qual__b' + (ist === q ? ' is-on' : '') + '" data-qual="' + q + '" data-art="' + esc(a.h) + '"><b>' + nm + '</b><small>' + sub[q] + '</small><span>' + eur(tierPreis(S.geraet.h, a.h, q)) + '</span></button>';
          }).join('') + '</div>';
        }
        return '<div class="kfg-optwrap">' + knopf + qual + '</div>';
    }
    elBody.querySelector('[data-aendern]').addEventListener('click', function () { gehe(0); });
    function preisAuffrischen(h) {
      var el = elBody.querySelector('[data-preis="' + h + '"]');
      if (!el) return;
      var p = preisFuer(S.geraet.h, h);
      el.textContent = p === null ? 'Auf Anfrage' : ((istAb(S.geraet.h, h) || (hatQual(S.geraet.h, h) && !S.qual[h])) ? 'ab ' : '') + eur(p);
      el.classList.toggle('kfg-option__p--leise', p === null);
    }
    elBody.querySelectorAll('.kfg-option[data-art]').forEach(function (b) { b.addEventListener('click', function () {
      var h = b.dataset.art, i = S.arten.indexOf(h);
      if (i === -1) S.arten.push(h); else S.arten.splice(i, 1);
      var an = S.arten.indexOf(h) !== -1;
      b.classList.toggle('is-on', an); b.setAttribute('aria-pressed', String(an));
      var q = elBody.querySelector('[data-qual-fuer="' + h + '"]'); if (q) q.hidden = !an;
      fussLeiste(true, S.arten.length > 0, 'Weiter');
    }); });
    elBody.querySelectorAll('.kfg-qual__b').forEach(function (b) { b.addEventListener('click', function (e) {
      e.stopPropagation();
      var h = b.dataset.art;
      S.qual[h] = b.dataset.qual;
      elBody.querySelectorAll('[data-qual-fuer="' + h + '"] .kfg-qual__b').forEach(function (x) { x.classList.toggle('is-on', x === b); });
      preisAuffrischen(h);
      fussLeiste(true, S.arten.length > 0, 'Weiter');
    }); });
    fussLeiste(true, S.arten.length > 0, 'Weiter');
  }
  function feld(key, label, wert, extra, typ) { return '<label class="kfg-feld ' + (extra || '') + '"><span>' + esc(label) + '</span><input type="' + (typ || 'text') + '" data-feld="' + key + '" value="' + esc(wert || '') + '"></label>'; }
  function versandText() {
    if (!(D.versandpreis > 0)) return 'Kostenlos';
    /* Zwei Zeilen: der Preis fett, die Frei-ab-Grenze klein darunter – auf dem Handy
       quetscht ein langer Preistext sonst die Beschreibung auf ein Wort pro Zeile. */
    return eur(D.versandpreis) + (D.versandFreiAb > 0 ? '<small>ab ' + eur(D.versandFreiAb).replace(',00', '') + ' kostenlos</small>' : '');
  }
  function schrittWeg() {
    function opt(key, ico, titel, sub, preis, klasse) { return '<button type="button" class="kfg-option' + (S.weg === key ? ' is-on' : '') + '" data-weg="' + key + '" aria-pressed="' + (S.weg === key) + '"><span class="kfg-radio" aria-hidden="true"></span><span class="kfg-option__ico">' + icon(ico) + '</span><span class="kfg-option__txt"><b>' + titel + '</b><small>' + sub + '</small></span><span class="kfg-option__p ' + (klasse || '') + '">' + preis + '</span></button>'; }
    var slugW = sammlungFuer(S.typ, S.marke);
    if (S.geraet && S.geraet.h !== '__unbekannt__' && !produktFertig[slugW]) ladeProdukte(S.typ, S.marke).then(function () { if (FLOW[idx] === 'weg') schrittWeg(); });
    var kauf = allesKaufbar();
    elBody.innerHTML = '<div class="kfg-optionen">' +
      opt('versand', 'paket', 'Einschicken', kauf ? 'Jetzt bezahlen, DHL-Label per E-Mail, versichert hin und zurück' : 'Versichert hin und zurück, DHL-Label per E-Mail nach Bestätigung', versandText(), D.versandpreis > 0 ? '' : 'kfg-option__p--frei') +
      opt('vorort', 'laden', 'Termin anfragen', 'Abgabe vor Ort in Nordhorn – Wunschtermin im nächsten Schritt, wir bestätigen', 'Kostenlos', 'kfg-option__p--frei') + '</div>' +
      (kauf ? '<p class="kfg-hinweis">Beim Einschicken kaufst du die Reparatur direkt – Festpreis, Zahlung an der Kasse, danach kommt das Versandlabel.</p>' : '');
    function pruefe() { fussLeiste(true, !!S.weg, 'Weiter'); }
    /* Express nur beim Einschicken – bei Abgabe vor Ort verschwindet die Kachel und der Haken geht aus. */
    function expressMalen() {
      var alt = elBody.querySelector('[data-kfg-express]'); if (alt) alt.remove();
      if (S.weg !== 'versand') { S.express = false; return; }
      elBody.querySelector('.kfg-optionen').insertAdjacentHTML('afterend', '<div class="kfg-optionen" data-kfg-express><button type="button" class="kfg-option' + (S.express ? ' is-on' : '') + '" data-express aria-pressed="' + S.express + '"><span class="kfg-check" aria-hidden="true">' + icon('haken', 'kfg-ico kfg-ico--mini') + '</span><span class="kfg-option__ico">' + icon('uhr') + '</span><span class="kfg-option__txt"><b>Express-Reparatur</b><small>Dein Gerät wird am Tag der Ankunft repariert und noch am selben Tag zurückgeschickt (Mo–Fr). Ist ein Ersatzteil nicht vorrätig, erstatten wir den Aufpreis.</small></span><span class="kfg-option__p">+' + eur(EXPRESS.preis) + '</span></button></div>');
      var b = elBody.querySelector('[data-express]');
      b.addEventListener('click', function () { S.express = !S.express; b.classList.toggle('is-on', S.express); b.setAttribute('aria-pressed', String(S.express)); pruefe(); });
    }
    function extrasMalen() {
      var alt = elBody.querySelector('[data-kfg-extras]'); if (alt) alt.remove();
      if (!extrasMoeglich()) { S.extras = {}; return; }
      /* Empfehlung passend zur Reparatur (nie vorausgewaehlt – § 312a Abs. 3 BGB): Display -> Panzerglas, Rueckseite/Kamera -> Kamera-Schutzglas. */
      var hat = function (a) { return S.arten.indexOf(a) !== -1; };
      var empf = { pg: hat('display') || hat('touchscreen'), kam: hat('rueckseite') || hat('kameraglas') || hat('rueckseitige-kamera') };
      var EMPF_TXT = { pg: 'Schützt dein neues Display direkt ab Tag 1', kam: 'Schützt die neue Kameralinse direkt ab Tag 1' };
      var html = '<div class="kfg-optionen" data-kfg-extras><p class="kfg-hinweis" style="margin:4px 0 0"><b>Beliebte Extras</b> – wir bringen es direkt nach der Reparatur an</p>' + EXTRAS.map(function (x) {
        var an = !!S.extras[x.k], e = empf[x.g] && x.k !== 'pgp';
        var badge = e ? ' <span style="display:inline-block;margin-left:6px;padding:2px 8px;border-radius:999px;background:var(--as-action,#0071e3);color:#fff;font-size:11px;font-weight:700;vertical-align:1px">Empfohlen</span>' : '';
        var sub = e ? EMPF_TXT[x.g] + ' – ' + x.s.charAt(0).toLowerCase() + x.s.slice(1) : x.s;
        return '<button type="button" class="kfg-option' + (an ? ' is-on' : '') + '" data-extra="' + x.k + '" aria-pressed="' + an + '"' + (e ? ' style="border-color:var(--as-action,#0071e3)"' : '') + '><span class="kfg-check" aria-hidden="true">' + icon('haken', 'kfg-ico kfg-ico--mini') + '</span><span class="kfg-option__ico">' + icon(x.ico) + '</span><span class="kfg-option__txt"><b>' + esc(extraName(x)) + badge + '</b><small>' + esc(sub) + '</small></span><span class="kfg-option__p">+ ' + eur(x.preis) + '</span></button>';
      }).join('') + '</div>';
      var nach = elBody.querySelector('[data-kfg-express]') || elBody.querySelector('.kfg-optionen');
      nach.insertAdjacentHTML('afterend', html);
      elBody.querySelectorAll('[data-extra]').forEach(function (b) {
        b.addEventListener('click', function () {
          var x = EXTRAS.filter(function (e) { return e.k === b.dataset.extra; })[0], an = !S.extras[x.k];
          EXTRAS.forEach(function (e) { if (e.g === x.g) S.extras[e.k] = false; });
          S.extras[x.k] = an;
          elBody.querySelectorAll('[data-extra]').forEach(function (y) { var on = !!S.extras[y.dataset.extra]; y.classList.toggle('is-on', on); y.setAttribute('aria-pressed', String(on)); });
          pruefe();
        });
      });
    }
    elBody.querySelectorAll('[data-weg]').forEach(function (b) { b.addEventListener('click', function () { S.weg = b.dataset.weg; elBody.querySelectorAll('[data-weg]').forEach(function (x) { var an = x === b; x.classList.toggle('is-on', an); x.setAttribute('aria-pressed', String(an)); }); expressMalen(); extrasMalen(); pruefe(); }); });
    expressMalen();
    extrasMalen();
    pruefe();
  }
  function schrittTermin() {
    var heute = new Date(); heute.setHours(0, 0, 0, 0);
    var zeige = S.monat ? new Date(S.monat) : new Date(heute.getFullYear(), heute.getMonth(), 1);
    function male() {
      var jahr = zeige.getFullYear(), monat = zeige.getMonth(), tage = new Date(jahr, monat + 1, 0).getDate(), vorlauf = (new Date(jahr, monat, 1).getDay() + 6) % 7;
      var grenze = new Date(heute.getFullYear(), heute.getMonth() + 2, 1), zurueckAus = jahr === heute.getFullYear() && monat === heute.getMonth(), vorAus = new Date(jahr, monat, 1) >= grenze, zellen = '';
      for (var v = 0; v < vorlauf; v++) zellen += '<span></span>';
      for (var t = 1; t <= tage; t++) { var d = new Date(jahr, monat, t), zu = d < heute || D.geschlossen.indexOf(d.getDay()) !== -1, iso = jahr + '-' + String(monat + 1).padStart(2, '0') + '-' + String(t).padStart(2, '0'); zellen += '<button type="button" class="kfg-tag' + (zu ? ' is-zu' : '') + (S.datum === iso ? ' is-on' : '') + '"' + (zu ? ' disabled' : '') + ' data-tag="' + iso + '">' + t + '</button>'; }
      elBody.innerHTML = '<div class="kfg-monat"><button type="button" class="kfg-mnav" data-mon="-1"' + (zurueckAus ? ' disabled' : '') + ' aria-label="Voriger Monat">' + icon('pfeil-links', 'kfg-ico kfg-ico--klein') + '</button><b>' + MONATE[monat] + ' ' + jahr + '</b><button type="button" class="kfg-mnav" data-mon="1"' + (vorAus ? ' disabled' : '') + ' aria-label="Nächster Monat">' + icon('pfeil', 'kfg-ico kfg-ico--klein') + '</button></div>' +
        '<div class="kfg-wochentage">' + ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'].map(function (x) { return '<span>' + x + '</span>'; }).join('') + '</div><div class="kfg-tage">' + zellen + '</div><div class="kfg-zeiten" data-zeiten></div><p class="kfg-hinweis">' + esc(D.terminhinweis) + '</p>';
      elBody.querySelectorAll('[data-mon]').forEach(function (b) { b.addEventListener('click', function () { zeige = new Date(zeige.getFullYear(), zeige.getMonth() + Number(b.dataset.mon), 1); S.monat = zeige.getTime(); male(); }); });
      elBody.querySelectorAll('[data-tag]').forEach(function (b) { b.addEventListener('click', function () { S.datum = b.dataset.tag; S.zeit = null; elBody.querySelectorAll('[data-tag]').forEach(function (x) { x.classList.toggle('is-on', x === b); }); maleZeiten(); }); });
      maleZeiten();
    }
    function maleZeiten() {
      var ziel = elBody.querySelector('[data-zeiten]');
      if (!S.datum) { ziel.innerHTML = ''; fussLeiste(true, false, 'Weiter'); return; }
      var d = new Date(S.datum + 'T00:00:00'), slots = d.getDay() === 6 ? D.zeiten_samstag : D.zeiten;
      ziel.innerHTML = '<div class="kfg-zeit-kopf">' + TAGE[d.getDay()] + ', ' + d.getDate() + '. ' + MONATE[d.getMonth()] + '</div><div class="kfg-slots">' + slots.map(function (z) { return '<button type="button" class="kfg-slot' + (S.zeit === z ? ' is-on' : '') + '" data-zeit="' + z + '">' + z + '</button>'; }).join('') + '</div>';
      ziel.querySelectorAll('[data-zeit]').forEach(function (b) { b.addEventListener('click', function () { S.zeit = b.dataset.zeit; ziel.querySelectorAll('[data-zeit]').forEach(function (x) { x.classList.toggle('is-on', x === b); }); fussLeiste(true, true, 'Weiter'); }); });
      ziel.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      fussLeiste(true, !!S.zeit, 'Weiter');
    }
    male();
  }
  function zeile(l, w) { return '<div class="kfg-zeile-sum"><span>' + esc(l) + '</span><b>' + esc(w) + '</b></div>'; }
  function feldK(key, label, wert, typ, extra) { return '<label class="kfg-feld ' + (extra || '') + '"><span>' + esc(label) + '</span><input type="' + typ + '" data-kfeld="' + key + '" value="' + esc(wert || '') + '"></label>'; }
  /* Letzter Schritt beim Einschicken: Zusammenfassung, optionale Angaben, Einwilligung,
     dann echter Kauf ueber den Shopify-Warenkorb. */
  function schrittKasse() {
    var d = S.details, s = summe();
    var zeilen = S.arten.map(function (h) { var p = preisFuer(S.geraet.h, h), q = hatQual(S.geraet.h, h) ? ' · ' + qualName(h) : ''; return zeile(artName(h) + q, p === null ? 'auf Anfrage' : eur(p)); }).join('');
    elBody.innerHTML = '<div class="kfg-zusammenfassung">' + zeile('Gerät', S.geraet.n) + zeilen +
      (s.express ? zeile('Express-Reparatur', eur(s.express)) : '') +
      extrasGewaehlt().map(function (x) { return zeile(extraName(x), eur(x.preis)); }).join('') +
      zeile('Versand (DHL, versichert, hin & zurück)', s.versand > 0 ? eur(s.versand) : 'kostenlos') +
      '<div class="kfg-zeile-sum kfg-zeile-sum--total"><span>Gesamt</span><b>' + eur(s.betrag) + '</b></div></div>' +
      '<div class="kfg-felder">' +
        '<label class="kfg-feld kfg-feld--voll"><span>Was genau ist passiert? (optional)</span><textarea data-dfeld="fehler" rows="3" placeholder="z. B. Display gesprungen, Touch geht noch">' + esc(d.fehler || '') + '</textarea></label>' +
        '<label class="kfg-feld kfg-feld--voll"><span>IMEI oder Seriennummer (optional)</span><input type="text" data-dfeld="imei" value="' + esc(d.imei || '') + '" placeholder="Auf dem Handy *#06# eingeben" autocomplete="off"></label>' +
      '</div>' +
      okBlock() +
      '<p class="kfg-hinweis">Nach der Zahlung bekommst du die Bestellbestätigung mit Auftragsnummer und den Link zum DHL-Versandlabel per E-Mail. Den Entsperrcode schreibst du auf den Begleitschein im Paket – nie in dieses Formular.</p>' +
      '<div data-kfg-kasse-fehler class="kfg-fehler" role="alert" hidden></div>';
    function pruefe() { fussLeiste(true, !D.okKurz || S.ok, 'Zur Kasse'); }
    elBody.querySelectorAll('[data-dfeld]').forEach(function (i) { i.addEventListener('input', function () { d[i.dataset.dfeld] = i.value; }); });
    var okBox = elBody.querySelector('[data-kfg-ok]'), okMehr = elBody.querySelector('[data-kfg-ok-mehr]'), okText = elBody.querySelector('[data-kfg-ok-text]');
    if (okBox) okBox.addEventListener('change', function () { S.ok = okBox.checked; pruefe(); });
    if (okMehr && okText) okMehr.addEventListener('click', function () { var auf = okText.hidden; okText.hidden = !auf; okMehr.setAttribute('aria-expanded', String(auf)); okMehr.firstChild.nodeValue = auf ? 'Weniger anzeigen' : 'Mehr dazu'; });
    pruefe();
  }
  function kaufen() {
    var fehler = elBody.querySelector('[data-kfg-kasse-fehler]');
    var items = S.arten.map(function (h) {
      var id = varianteFuer(S.geraet.h, h);
      return id ? { id: id, quantity: 1, properties: {
        'Gerät': S.geraet.n,
        'Weg': 'Einschicken',
        'Fehlerbeschreibung': (S.details.fehler || '').trim() || '–',
        'IMEI / Seriennummer': (S.details.imei || '').trim() || '–',
        'Einwilligung': S.ok ? 'Ja, erteilt am ' + new Date().toLocaleDateString('de-DE') : 'nein'
      } } : null;
    }).filter(Boolean);
    if (!items.length) { if (fehler) { fehler.textContent = 'Diese Reparatur lässt sich gerade nicht online buchen – bitte als Anfrage senden.'; fehler.hidden = false; } return; }
    /* Express: Haken an jeder Reparatur-Position plus eigene Aufpreis-Position im selben Aufruf.
       Alte Express-Positionen fliegen unten mit raus (SKU REP-EXPRESS). */
    if (summe().express) {
      items.forEach(function (i) { i.properties['Express'] = 'Ja'; });
      items.push({ id: EXPRESS.id, quantity: 1, properties: { 'Für': S.geraet.n + ' – ' + S.arten.map(function (h) { return artName(h) + (hatQual(S.geraet.h, h) ? ' · ' + qualName(h) : ''); }).join(', ') } });
    }
    extrasGewaehlt().forEach(function (x) { items.push({ id: x.id, quantity: 1, properties: { 'Für': S.geraet.n } }); });
    elNext.disabled = true; elNext.querySelector('span').textContent = 'Einen Moment …';
    /* Alte Reparatur-Positionen aus dem Warenkorb nehmen (SKU REP-…), Ersatzteile
       und Geraete bleiben drin – die laufen mit derselben Kasse zusammen. */
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
      .then(function (c) {
        var alte = (c.items || []).filter(function (i) { return /^REP-/.test(i.sku || ''); });
        return alte.reduce(function (kette, i) {
          return kette.then(function () { return fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: i.key, quantity: 0 }) }); });
        }, Promise.resolve());
      })
      .catch(function () {})
      .then(function () { return fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) }); })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (x) {
        if (!x.ok) throw new Error(x.j && (x.j.description || x.j.message) || 'Fehler');
        window.location.href = '/checkout';
      })
      .catch(function (e) {
        elNext.disabled = false; elNext.querySelector('span').textContent = 'Zur Kasse';
        if (fehler) { fehler.textContent = 'Das hat nicht geklappt: ' + (e && e.message ? e.message : 'bitte noch einmal versuchen.'); fehler.hidden = false; }
      });
  }
  function schrittKontakt() {
    var k = S.kontakt, s = summe(), wa = whatsappUrl();
    /* Wer „Weitere Reparatur" gewaehlt hat, muss sagen was fehlt – sonst koennen wir keinen Preis nennen. */
    var sonst = S.arten.indexOf(SONST_H) !== -1;
    elBody.innerHTML = '<div class="kfg-zusammenfassung">' + zeile('Gerät', S.geraet.n) + zeile('Reparatur', S.arten.map(function (h) { return artName(h) + (hatQual(S.geraet.h, h) ? ' · ' + qualName(h) : ''); }).join(', ')) + zeile('Weg', S.weg === 'vorort' ? 'Terminanfrage (Abgabe vor Ort)' : 'Einschicken') +
      (S.weg === 'vorort' && S.datum ? zeile('Termin', terminText()) : '') +
      (s.express ? zeile('Express-Reparatur', eur(s.express)) : '') +
      extrasGewaehlt().map(function (x) { return zeile(extraName(x), eur(x.preis)); }).join('') +
      '<div class="kfg-zeile-sum kfg-zeile-sum--total"><span>' + (s.offen > 0 && s.betrag > 0 ? 'Festpreis ab' : (s.offen > 0 ? 'Preis' : 'Festpreis')) + '</span><b>' + (s.offen > 0 && s.betrag === 0 ? 'auf Anfrage' : eur(s.betrag)) + '</b></div>' +
      (s.offen > 0 ? '<p class="kfg-hinweis">Für ' + s.offen + ' der gewählten Punkte nennen wir den Preis nach kurzer Prüfung.</p>' : '') + '</div>' +
      '<div class="kfg-felder">' + feldK('name', 'Name', k.name, 'text', 'kfg-feld--voll') + feldK('tel', 'Telefon', k.tel, 'tel') + feldK('mail', 'E-Mail', k.mail, 'email') + '<label class="kfg-feld kfg-feld--voll"><span>' + (sonst ? 'Was ist kaputt? Bitte kurz beschreiben' : 'Anmerkung (optional)') + '</span><textarea data-kfeld="text" rows="3"' + (sonst ? ' required placeholder="z. B. Gerät geht nicht mehr an, war vorher im Wasser"' : '') + '>' + esc(k.text || '') + '</textarea></label></div>' +
      okBlock() +
      (wa ? '<a class="kfg-wa" href="' + wa + '" target="_blank" rel="noopener">' + icon('whatsapp', 'kfg-ico kfg-ico--klein') + 'Lieber per WhatsApp anfragen</a>' : '');
    function pruefe() { fussLeiste(true, !!(k.name && k.tel && k.mail && k.mail.indexOf('@') > 0 && (!D.okKurz || S.ok) && (!sonst || (k.text || '').trim().length > 4)), 'Anfrage absenden'); }
    elBody.querySelectorAll('[data-kfeld]').forEach(function (i) { i.addEventListener('input', function () { k[i.dataset.kfeld] = i.value; pruefe(); }); });
    var okBox = elBody.querySelector('[data-kfg-ok]'), okMehr = elBody.querySelector('[data-kfg-ok-mehr]'), okText = elBody.querySelector('[data-kfg-ok-text]');
    if (okBox) okBox.addEventListener('change', function () { S.ok = okBox.checked; pruefe(); });
    if (okMehr && okText) okMehr.addEventListener('click', function () {
      var auf = okText.hidden;
      okText.hidden = !auf;
      okMehr.setAttribute('aria-expanded', String(auf));
      okMehr.firstChild.nodeValue = auf ? 'Weniger anzeigen' : 'Mehr dazu';
    });
    pruefe();
  }
  /* Einwilligung: Pflicht-Haken, langer Text nur auf Wunsch sichtbar. */
  function okBlock() {
    if (!D.okKurz) return '';
    return '<div class="kfg-ok">'
      + '<label class="kfg-ok__zeile"><input type="checkbox" data-kfg-ok' + (S.ok ? ' checked' : '') + '><span><b class="kfg-ok__stern">*</b> ' + esc(D.okKurz) + '</span></label>'
      + (D.okText ? '<button type="button" class="kfg-ok__mehr" data-kfg-ok-mehr aria-expanded="false">Mehr dazu<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg></button>'
        + '<div class="kfg-ok__text" data-kfg-ok-text hidden>' + D.okText.split('\n').filter(function (z) { return z.trim(); }).map(function (z) { return '<p>' + esc(z.trim()) + '</p>'; }).join('') + '</div>' : '')
      + '</div>';
  }

  /* ---------- Absenden ---------- */
  function setz(name, wert) { var i = form.querySelector('[name="' + name + '"]'); if (!i) { i = document.createElement('input'); i.type = 'hidden'; i.name = name; form.appendChild(i); } i.value = wert == null ? '' : wert; }
  /* Schnellantwort-Link fuer die Werkstatt-Mail: nur https ist in Shopifys Anfrage-Mail
     anklickbar, deshalb /pages/antwort mit den Daten kodiert in der Adresse. */
  function antwortLink(arten, weg, preis) {
    if (!D.antwortUrl) return '';
    var d = { t: 'reparatur', n: (S.kontakt.name || '').trim(), e: (S.kontakt.mail || '').trim(), p: (S.kontakt.tel || '').trim(), g: S.geraet.n + ' (' + S.typ + ')', z: arten.join(', '), x: weg + (S.weg === 'vorort' && S.datum ? ' · ' + terminText() : '') + ' · ' + preis };
    var b = btoa(unescape(encodeURIComponent(JSON.stringify(d)))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    var tel = String(S.kontakt.tel || '').replace(/[^0-9+]/g, '').replace(/^\+/, ''); if (tel.indexOf('0') === 0) tel = '49' + tel.slice(1);
    return '\n\n--- Schnellantwort (Link antippen, Antwort wählen, senden) ---\n' + (D.origin || '') + D.antwortUrl + '?d=' + b + (tel.length > 8 ? '\nWhatsApp direkt: https://wa.me/' + tel : '');
  }
  /* Klemmt der Spamschutz (hCaptcha laedt nicht), passiert nach dem Klick gar nichts.
     Nach 8 s zeigen wir WhatsApp und Mail-App als Ausweg, mit dem fertigen Text. */
  function notausgang() {
    var inhalt = (form.querySelector('[name="contact[body]"]') || {}).value || '';
    setTimeout(function () {
      if (FLOW[idx] !== 'kontakt' || elBody.querySelector('[data-kfg-notaus]')) return;
      var wa = whatsappUrl(), n = document.createElement('div');
      n.className = 'kfg-notaus'; n.setAttribute('data-kfg-notaus', '');
      n.innerHTML = '<b>Das Senden hängt gerade.</b> Die Anfrage geht auch so raus:' +
        (wa ? '<a class="kfg-wa" href="' + wa + '" target="_blank" rel="noopener">Per WhatsApp anfragen</a>' : '') +
        (D.shopMail ? '<a class="kfg-wa kfg-wa--mail" href="mailto:' + D.shopMail + '?subject=' + encodeURIComponent('Reparatur-Anfrage: ' + S.geraet.n) + '&body=' + encodeURIComponent(inhalt) + '">Per E-Mail-App senden</a>' : '');
      elBody.appendChild(n); n.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }, 8000);
  }
  function captchaVorladen() { try { if (form && window.Shopify && window.Shopify.captcha && typeof window.Shopify.captcha.protect === 'function') window.Shopify.captcha.protect(form); } catch (e) {} }
  function absenden() {
    if (!form) return;
    var s = summe(), arten = S.arten.map(function (h) { var p = preisFuer(S.geraet.h, h), q = hatQual(S.geraet.h, h) ? ', ' + qualName(h) : ''; return artName(h) + q + ' (' + (p === null ? 'auf Anfrage' : eur(p)) + ')'; }), weg = (S.weg === 'vorort' ? 'Terminanfrage (Abgabe vor Ort)' : 'Einschicken') + (s.express ? ' + Express-Reparatur (' + eur(s.express) + ')' : ''), preis = preisText(s);
    setz('contact[name]', S.kontakt.name); setz('contact[email]', S.kontakt.mail); setz('contact[phone]', S.kontakt.tel);
    setz('contact[Geraet]', S.geraet.n + ' (' + S.typ + ')'); setz('contact[Reparatur]', arten.join(' | ')); setz('contact[Festpreis]', preis); setz('contact[Weg]', weg);
    setz('contact[Termin]', S.weg === 'vorort' && S.datum ? terminText() : '–');
    if (D.okKurz) setz('contact[Einwilligung]', S.ok ? 'Ja, erteilt am ' + new Date().toLocaleDateString('de-DE') : 'nein');
    setz('contact[Adresse]', '–');
    setz('contact[body]', (S.kontakt.text || '') + '\n\n--- Preis-Check ---\nGerät: ' + S.geraet.n + '\nReparatur: ' + arten.join(', ') + '\nWeg: ' + weg + (S.weg === 'vorort' && S.datum ? '\nTermin: ' + terminText() : '') + '\nSumme: ' + preis + antwortLink(arten, weg, preis));
    /* Ab hier uebernimmt der Browser: der Knopf ist im letzten Schritt ein echter
       Absende-Knopf des Formulars (type=submit, form=AsKfgForm). Nur so setzt
       Shopifys Spamschutz seinen Token – per JS ausgeloestes Absenden endet bei
       "Missing CAPTCHA token" und die Anfrage erreicht die Werkstatt nie. */
    try { sessionStorage.setItem('as_kfg_weg', S.weg || ''); } catch (e) {}
  }

  /* ---------- Oeffentliche Schnittstelle ---------- */
  window.AsKfg = {
    open: function (opts, ausloeser) {
      opts = opts || {};
      if (opts.geraet) {
        var g = D.geraete.filter(function (x) { return x.h === opts.geraet; })[0];
        if (g) {
          S.typ = g.t; S.marke = g.m; S.geraet = g;
          ladeProdukte(g.t, g.m);
          S.arten = opts.reparatur && D.arten.some(function (a) { return a.h === opts.reparatur; }) ? [opts.reparatur] : [];
          idx = FLOW.indexOf('reparatur'); gezeichnet = false;
        }
      } else if (opts.typ) {
        if (S.typ !== opts.typ) { S.marke = null; S.geraet = null; S.arten = []; }
        S.typ = opts.typ; idx = FLOW.indexOf('marke'); gezeichnet = false;
      }
      oeffne(ausloeser || null);
    },
    close: schliesse
  };
  document.addEventListener('as:kfg-open', function (e) { window.AsKfg.open(e.detail || {}, null); });

  /* ---------- Start ---------- */
  if (root) {
    captchaVorladen(); window.addEventListener('load', captchaVorladen);
    elBack.addEventListener('click', zurueck);
    elNext.addEventListener('click', function (e) {
      if (FLOW[idx] === 'kasse') { e.preventDefault(); kaufen(); return; }
      if (FLOW[idx] !== 'kontakt') { e.preventDefault(); weiter(); return; }
      absenden();   /* fuellt die Felder, danach sendet der Browser das Formular selbst */
      notausgang();
    });
  }
  var q = new URLSearchParams(window.location.search), vg = q.get('geraet');
  if (vg) window.AsKfg.open({ geraet: vg, reparatur: q.get('reparatur') }, null);
  else if (q.get('typ')) window.AsKfg.open({ typ: q.get('typ') }, null);
  else if (inline && root) { zeichne(); gezeichnet = true; }
  /* Danke-Karte nur zeigen, wenn die Anfrage wirklich aus dem Preis-Check kam (Marker aus absenden()),
     nicht wenn ein anderes Kontaktformular auf der Seite abgeschickt wurde. */
  var dankeWrap = document.querySelector('[data-kfg-danke-wrap]');
  if (dankeWrap) {
    var wegWar = null; try { wegWar = sessionStorage.getItem('as_kfg_weg'); sessionStorage.removeItem('as_kfg_weg'); } catch (e) {}
    if (wegWar !== null) {
      if (wegWar !== 'versand') { var dhl = dankeWrap.querySelector('[data-kfg-dhl]'); if (dhl) dhl.hidden = true; }
      if (root) root.hidden = true;
      dankeWrap.hidden = false;
      var dc = dankeWrap.querySelector('[data-kfg-close]'); if (dc) dc.addEventListener('click', schliesse);
      oeffne(null);
    } else { dankeWrap.remove(); }
  }
})();
/* ===== AS-Electronics: Reparatur-Zentrale (Preis-Check -> Zentrale) ===== */
(function () {
  var ZENTRALE = 'https://script.google.com/macros/s/AKfycby3q31kA1DrXYkz6HtfD-ER0HdPeSvyE1dKOTNY_ftE6lsaJbxW_EZztdgyhhkJsaI/exec';
  var MON = ['januar','februar','märz','april','mai','juni','juli','august','september','oktober','november','dezember'];
  function wert(f, n) { var e = f.querySelector('[name="contact[' + n + ']"]'); return e ? String(e.value || '').trim() : ''; }
  function iso(t) {
    var m = String(t || '').toLowerCase().match(/(\d{1,2})\.\s*([a-zäöü]+)\s+(\d{4}),?\s*(\d{1,2}):(\d{2})/);
    if (!m || MON.indexOf(m[2]) < 0) return '';
    var p = function (x) { return ('0' + x).slice(-2); };
    return m[3] + '-' + p(MON.indexOf(m[2]) + 1) + '-' + p(m[1]) + 'T' + p(m[4]) + ':' + m[5];
  }
  var form = document.getElementById('AsKfgForm');
  if (form) form.addEventListener('submit', function () {
    try {
      var preis = wert(form, 'Festpreis'), weg = wert(form, 'Weg'), termin = wert(form, 'Termin');
      var cent = /zzgl|anfrage/i.test(preis) ? 0 : Math.round(parseFloat(preis.replace(/[^\d,]/g, '').replace(',', '.')) * 100) || 0;
      sessionStorage.setItem('as_rep_daten', JSON.stringify({
        typ: 'reparatur', Name: wert(form, 'name'), email: wert(form, 'email'), Telefon: wert(form, 'phone'),
        Geraet: wert(form, 'Geraet'), Reparatur: wert(form, 'Reparatur'), Festpreis: preis, PreisCent: cent, Weg: weg,
        Termin: termin, TerminISO: iso(termin), Express: /express/i.test(weg) ? 'ja' : '',
        Anmerkung: wert(form, 'body').split('--- Preis-Check ---')[0].trim()
      }));
    } catch (e) {}
  }, true);
  if (document.querySelector('[data-kfg-danke-wrap]')) {
    try {
      var d = sessionStorage.getItem('as_rep_daten'); sessionStorage.removeItem('as_rep_daten');
      if (d) { var fd = new URLSearchParams(JSON.parse(d)); if (!(navigator.sendBeacon && navigator.sendBeacon(ZENTRALE, fd))) fetch(ZENTRALE, { method: 'POST', mode: 'no-cors', body: fd }); }
    } catch (e) {}
  }
})();
